// Function to add random offset (converted from Python example)
export const addLocationOffset = (latitude: number, longitude: number, maxOffsetMiles: number = 2): { latitude: number, longitude: number } => {
    const milesPerLatDegree = 69.0;
    const milesPerLngDegree = Math.abs(Math.cos(latitude * (Math.PI / 180)) * milesPerLatDegree);

    // Ensure milesPerLngDegree is not zero (can happen at poles, though unlikely for user input)
    if (milesPerLngDegree === 0) {
        return { latitude, longitude }; // Return original if cannot calculate longitude offset
    }

    const offsetDistance = Math.random() * (maxOffsetMiles - 0.2) + 0.2; // 0.2 to max_offset_miles
    const angle = Math.random() * 2 * Math.PI;

    const nsOffset = offsetDistance * Math.cos(angle);
    const ewOffset = offsetDistance * Math.sin(angle);

    const latOffset = nsOffset / milesPerLatDegree;
    const lngOffset = ewOffset / milesPerLngDegree;

    return {
        latitude: latitude + latOffset,
        longitude: longitude + lngOffset,
    };
};

// Async function to geocode using Nominatim and apply offset
export const geocodeAndOffsetLocation = async (
    city: string,
    country: string,
    zipcode: string
): Promise<{ latitude: number; longitude: number } | null> => {
    const queryParams = new URLSearchParams({
        format: 'json',
        city: city,
        country: country,
        limit: '1' // Only need the top result
    });

    // Add postalcode only if country is US (or similar checks if expanding)
    if (country?.toLowerCase() === 'united states' || country?.toLowerCase() === 'us') {
        queryParams.set('postalcode', zipcode);
    }

    const url = `https://nominatim.openstreetmap.org/search?${queryParams.toString()}`;
    // console.log(`Geocoding query: ${url}`); // Remove debug log for URL

    try {
        const response = await fetch(url, {
            headers: {
                'Accept': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`Nominatim API request failed with status: ${response.status}`);
        }

        const data = await response.json();

        if (data && data.length > 0) {
            const location = data[0];
            const lat = parseFloat(location.lat);
            const lon = parseFloat(location.lon);

            if (!isNaN(lat) && !isNaN(lon)) {
                console.log(`Geocoded original: ${lat}, ${lon}`);
                const offsetCoords = addLocationOffset(lat, lon);
                console.log(`Geocoded with offset: ${offsetCoords.latitude}, ${offsetCoords.longitude}`);
                return offsetCoords;
            } else {
                console.error("Failed to parse lat/lon from Nominatim response", location);
                return null;
            }
        } else {
            console.warn(`No geocoding results found for query: ${url}`);
            return null;
        }
    } catch (error) {
        console.error("Geocoding fetch error:", error);
        return null;
    }
}; 